import { useEffect, useState } from "react";
import { MdCheckCircle } from "react-icons/md";
import { getInlineLoader } from "../Helpers";
import logo_icon from '../assets/logo_icon.png';
import logo from '../assets/logo.png';
import OneObjective from "./OneObjective";

export default function AboutUsContent() {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div className="MainBodySection" style={{ paddingBottom: "50px", paddingTop: "50px" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="main-section-title">About Hospium<span style={{ display: "block", borderBottom: "3px solid var(--secondaryColor)", width: "50px", marginTop: "10px" }} /></h6>
          </div>
          <div className="col-md-6 text-center mb-3 mt-3">
            <div className="card bg-primary"><div className="card-body text-center">
              <img src={logo_icon} alt="Hospium icon" style={{ width: "80px" }} /><br />
              <img src={logo} alt="Hospium" style={{ width: "250px", maxWidth: "100%" }} />
            </div></div>
          </div>
          <div className="col-md-6 mt-3 mb-3">
            <h6 className="font-bold" style={{ fontSize: "24px" }}>WHO WE ARE</h6>
            <p style={{ fontSize: "16px" }}>Hospium is a modular digital healthcare ecosystem for hospitals, pharmacies, healthcare teams, and patients. It brings essential workflows together without forcing every organization into the same operating model.</p>
            <p style={{ fontSize: "16px" }}>Each deployment can be configured and branded for the client while remaining connected to a consistent, maintainable product foundation.</p>
          </div>
          <div className="col-md-6 bg-primary">
            <h6 className="text-center font-bold mt-5 mb-2" style={{ fontSize: "32px", textTransform: "uppercase" }}>Our Vision</h6>
            <h6 className="font-semi-bold" style={{ fontSize: "16px", padding: "20px" }}>A healthcare environment where trusted information and practical digital tools connect every step of the care journey.</h6>
          </div>
          <div className="col-md-6 bg-surface">
            <h6 className="text-center font-bold mt-5 mb-2" style={{ fontSize: "32px", textTransform: "uppercase" }}>Our Mission</h6>
            <h6 className="font-semi-bold" style={{ fontSize: "16px", padding: "20px" }}>To deliver simple, secure, and operational healthcare products that help organizations serve patients better.</h6>
          </div>
          <div className="col-md-12 mt-5">
            <h6 className="text-center font-bold mb-2" style={{ fontSize: "32px", textTransform: "uppercase" }}>Our Principles</h6>
            <div className="row">
              {["Operational simplicity", "Connected care", "Patient dignity", "Reliable information", "Flexible deployment", "Sustainable growth"].map((value) => (
                <div className="col-md-4" key={value}><OneObjective icon={<MdCheckCircle size={42} className="text-primary" />} content={value} /></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
